import React,{ useEffect, useState } from 'react';
import Amount from '../options/Amount';
import Remark from '../options/Remark';
const Nidin_Options = ( { handleAdd, handleSubtract, formValues, handleInputChange } ) => {
  return (
    <>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <Remark formValues = { formValues }  handleInputChange = { handleInputChange }/>
    <Amount handleAdd={ handleAdd } handleSubtract={ handleSubtract } formValues = { formValues }/>
    </>
  );
};

export default Nidin_Options;
